// extracted by css-extract-rspack-plugin
export default {"overlay":"Lbbs4xdrIfquEJSd","container":"Ehygz1esMTk2ybHP","icon":"Bgk_8P_qoNugw3Yy","textContainer":"rkHQIGUjsmAvgdcr","title":"w3yvnmAdnOMCVMQA","subtitle":"h3z45yoZfwcCM6lt"};